import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import type { Router } from 'vue-router'
import store from '@/store'
import { getSimulated } from '@/utils/simulated'

export default function verifyLoginGuard(router: Router) {
  router.beforeEach(async (_to, _from, next) => {
    NProgress.start()
    const { loadUser } = store.authStore
    const { loginStatus } = storeToRefs(store.authStore)
    try {
      if (loginStatus.value === 2) {
        next()
        return
      }
      if (getSimulated()) {
        next()
        return
      }
      await loadUser()
      next()
    }
    finally {
      NProgress.done()
    }
  })
}
